// @ts-strict-ignore
import React from 'react';

import { StickyHeaderLinksGradBlockData } from 'api/cms';
import { useHasGradProgram, useLoggedIn } from 'cms/hooks';
import { CallToActionButton } from 'components/Button';

import { StickyHeaderLinks } from './StickyHeaderLinks';

type Props = {
  data: StickyHeaderLinksGradBlockData;
};

export function StickyHeaderLinksGradBlock({ data: { links } }: Props) {
  const loggedIn = useLoggedIn();
  const hasGradProgram = useHasGradProgram();

  return (
    <StickyHeaderLinks
      links={links}
      button={
        <CallToActionButton
          loggedIn={loggedIn}
          hasGradProgram={hasGradProgram}
        />
      }
    />
  );
}
